// extracted by mini-css-extract-plugin
module.exports = {"container":"not-found__index__container--2MWYWFep"};